import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ReceivableFinancingPage2UI from './ReceivableFinancingPage2UI.js'

class ReceivableFinancingPage2SF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loanList: null,
    }
  }

  render() {
    return (
      <ReceivableFinancingPage2UI
        context={this.props.context}
        errorList={this.state.errorList}
        loanList={this.state.loanList}
        onRefreshClick={this.onRefreshClick}
        openOrClosed='receivableFinancing'
        pageTitle='Receivable Financing'
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    const queryParameters = new URLSearchParams(window.location.search)
    this.getLoans(context)
  }

  getLoans(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans`,
      cacheKey: CacheKeys.AllLoans('open'),
      callback: this.getLoansCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, { openOrClosed: 'open' })
  }

  getLoansCallback = (response) => {
    this.setState({ errorList: response.errorList, loanList: response.loanList })
  }

  onRefreshClick = () => {
    /*
    this.state.loanList.forEach(loan => {
      CacheManager.removeObject(CacheKeys.BillsByLoanId(loan.loanId))
      CacheManager.removeObject(CacheKeys.Orders(loan.loanId, ''))
      if (loan.termSheet)
        CacheManager.removeObject(CacheKeys.Order(loan.termSheet.estimateId))
    })
    */
    CacheManager.removeObject(CacheKeys.AllLoans('open'))
    this.setState({ loanList: null, errorList: null })
    this.getLoans(this.props.context)
  }
}

export default ReceivableFinancingPage2SF
